require('./accountDirectDebitStep2.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');

//@helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getCurrentAccounts } = require('utilities/currentAccountsHelper');

//@commons
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

class AccountDirectDebitStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
    }

    handleAccountFromChange(accountId) {
        this.props.setAccount(accountId);
    }

    render() {
        const { immAccounts, initialAccountId, isInactiveAccountsEnabled, fromAccount } = this.props;
        const accountsById = immAccounts.get('byId');
        const accountsIndexes = getCurrentAccounts(immAccounts.get('byOrder').toJS(), accountsById);
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        return (
            <div className="account-direct-debit-step2">
                <div className="account-direct-debit-step2__content">
                    <h2 className="account-direct-debit-step2__content-title">
                        <FormattedText value="accountDirectDebitStep2-title"/>
                    </h2>
                </div>
                <div className="account-direct-debit-step2__account-select">
                    <DropdownAccounts
                        label={formatText('accountDirectDebitStep2-description1')}
                        immAccounts={accountsById}
                        currentAccountId={fromAccount}
                        accountsIndexes={accountsIndexes}
                        onAccountChange={this.handleAccountFromChange}
                        initialAccountId={initialAccountId}
                        tooltipMsg={tooltipMsgContent}
                        showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    />
                </div>
            </div>
        );
    }
}

AccountDirectDebitStep2.propTypes = {
    immAccounts: PropTypes.object,
    initialAccountId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAccount: PropTypes.func,
    fromAccount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired
};

module.exports = AccountDirectDebitStep2;
